export const DICTATION_GUIDE_PATH = 'articles/11129458-dictation-using-your-voice';

// Anchors directly to the "setup" section of the dictation guide so the
// troubleshooting link lands users on the setup instructions.
export const DICTATION_SETUP_GUIDE_PATH = 'articles/11129458-dictate#h_308c8a6e2b';
